import cx from 'classnames'
import { Toggle } from '@cinch-labs/design-system'
import { MouseEventHandler, useState } from 'react'
import { SearchMode } from '../../utils'
import styles from './search-mode-toggle.module.css'

type SearchModeToggleProps = {
  activeMode: SearchMode
  usedCarsUrl: string
  newCarsUrl: string
  className?: string
  onBeforeNavigate?: () => Promise<void> | void
}

export const SearchModeToggle = ({
  activeMode,
  usedCarsUrl,
  newCarsUrl,
  className,
  onBeforeNavigate,
}: SearchModeToggleProps) => {
  const [pendingMode, setPendingMode] = useState<SearchMode | null>(null)

  const handleToggleSelected: MouseEventHandler<HTMLInputElement> = async (
    event,
  ) => {
    const targetMode = event.currentTarget.id as SearchMode
    const targetUrl = targetMode === 'used' ? usedCarsUrl : newCarsUrl

    setPendingMode(targetMode)

    if (onBeforeNavigate) {
      await onBeforeNavigate()
    }

    window.location.assign(targetUrl)
  }

  const visibleActiveMode = pendingMode ?? activeMode

  return (
    <div
      className={cx(styles.root, className, {
        [styles.pending]: pendingMode !== null,
      })}
    >
      <Toggle
        name="search-mode"
        onSelected={handleToggleSelected}
        classNames={{
          container: styles.toggleContainer,
          label: styles.toggleLabel,
        }}
        options={[
          {
            id: 'used',
            label: 'Used cars',
            defaultValue: 'used',
            defaultChecked: visibleActiveMode === 'used',
          },
          {
            id: 'new',
            label: 'New cars',
            defaultValue: 'new',
            defaultChecked: visibleActiveMode === 'new',
          },
        ]}
      />
    </div>
  )
}
